var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import { Dependencies } from "~/core/decorator";
import { OutsourceStayService } from "~/services/domain-service/outsource-stay-manage.service";
import caseDistribution from "./case-distribution.vue"; // 案件分配
var SelectEntrusted = /** @class */ (function (_super) {
    __extends(SelectEntrusted, _super);
    function SelectEntrusted() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = []; //选中的数据
        _this.dataSet = []; //受托方列表数据
        _this.dialog = {
            caseDistribution: false
        };
        return _this;
    }
    SelectEntrusted.prototype.emitClose = function () {
        this.selectionList = [];
        this.refresh();
    };
    SelectEntrusted.prototype.emitSuccess = function () { };
    SelectEntrusted.prototype.refresh = function () {
        var _this = this;
        // 默认加载列表
        this.outsourceStayService
            .searchOutsourcePreview(this.isLawsuit, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    Object.defineProperty(SelectEntrusted.prototype, "commissionIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.outsourceId; });
        },
        enumerable: false,
        configurable: true
    });
    SelectEntrusted.prototype.onClose = function () {
        this.dialog.caseDistribution = false;
        this.emitClose();
    };
    SelectEntrusted.prototype.onSuccess = function () {
        this.dialog.caseDistribution = false;
        this.emitClose();
        // 提示父页面进行数据刷新
        this.emitSuccess();
    };
    SelectEntrusted.prototype.onOpen = function () {
        var _this = this;
        this.$nextTick(function () {
            var component = _this.$refs.distribution;
            component.refreshData();
        });
    };
    __decorate([
        Dependencies(PageService)
    ], SelectEntrusted.prototype, "pageService", void 0);
    __decorate([
        Dependencies(OutsourceStayService)
    ], SelectEntrusted.prototype, "outsourceStayService", void 0);
    __decorate([
        Prop({
            required: true,
            default: function () { return []; }
        })
    ], SelectEntrusted.prototype, "selectedCaseIds", void 0);
    __decorate([
        Prop({ required: true })
    ], SelectEntrusted.prototype, "isLawsuit", void 0);
    __decorate([
        Emit("close")
    ], SelectEntrusted.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], SelectEntrusted.prototype, "emitSuccess", null);
    SelectEntrusted = __decorate([
        Component({
            components: {
                caseDistribution: caseDistribution
            }
        })
    ], SelectEntrusted);
    return SelectEntrusted;
}(Vue));
export default SelectEntrusted;
